import React, { useState } from "react";
import { FiCheckCircle } from "react-icons/fi";
import { HITO_ESTADO_LABELS, confirmationChanges } from "./hitosModel";

// Confirmación de un hito crítico. Lo que se decide aquí queda como cambio pendiente
// de la ficha (estado, fecha real y nota) y se guarda con el resto, con su historial.
const OPCIONES = [
    { estado: "OK", help: "El hito se ha cumplido. Indica cuándo." },
    { estado: "NA", help: "Este hito no aplica a esta obra." },
    { estado: "RIESGO", help: "Hay un problema: queda marcado como alerta hasta resolverlo." },
    { estado: "PENDIENTE", help: "Deshace la confirmación: vuelve a contar como pendiente." },
];

export default function HitoConfirmModal({ obraLabel, hito, todayIso, formatDate, onSubmit, onClose }) {
    const [estado, setEstado] = useState(hito.estado === "PENDIENTE" ? "OK" : hito.estado);
    const [realDate, setRealDate] = useState(hito.realDate || todayIso);
    const [notes, setNotes] = useState(hito.notes || "");
    const [error, setError] = useState("");

    const submit = (event) => {
        event.preventDefault();
        try {
            onSubmit(confirmationChanges(hito.field, { estado, realDate, notes }));
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className="obras-confirm-layer" role="dialog" aria-modal="true" aria-labelledby="obras-hito-title" onMouseDown={onClose}>
            <form className="obras-confirm obras-hito-confirm" onMouseDown={(event) => event.stopPropagation()} onSubmit={submit}>
                <h3 id="obras-hito-title" className="obras-confirm__title">
                    <FiCheckCircle aria-hidden="true" /> {hito.label}
                </h3>
                <p className="obras-hito-confirm__obra">{obraLabel}</p>
                <dl className="obras-hito-confirm__facts">
                    <div><dt>Fecha prevista</dt><dd>{hito.date ? formatDate(hito.date) : "Sin fecha"}</dd></div>
                    <div><dt>Situación</dt><dd><span className={`obras-hito-chip tone-${hito.tone}`}>{hito.statusLabel}</span></dd></div>
                </dl>

                <fieldset className="obras-hito-confirm__options">
                    <legend>¿Cómo queda el hito?</legend>
                    {OPCIONES.map((opcion) => (
                        <label key={opcion.estado} className={estado === opcion.estado ? "is-active" : ""}>
                            <input
                                type="radio"
                                name="hito-estado"
                                value={opcion.estado}
                                checked={estado === opcion.estado}
                                onChange={() => { setEstado(opcion.estado); setError(""); }}
                            />
                            <span>
                                <strong>{HITO_ESTADO_LABELS[opcion.estado]}</strong>
                                <small>{opcion.help}</small>
                            </span>
                        </label>
                    ))}
                </fieldset>

                {estado === "OK" ? (
                    <label className="obras-hito-confirm__field">
                        <span>Fecha real</span>
                        <input type="date" value={realDate} max={todayIso} required onChange={(event) => { setRealDate(event.target.value); setError(""); }} />
                    </label>
                ) : null}
                {estado !== "PENDIENTE" ? (
                    <label className="obras-hito-confirm__field">
                        <span>Nota <small>(opcional)</small></span>
                        <textarea rows={3} maxLength={300} value={notes} placeholder="Qué se ha recibido, quién lo confirma..." onChange={(event) => setNotes(event.target.value)} />
                    </label>
                ) : null}
                {error ? <p className="obras-hito-confirm__error" role="alert">{error}</p> : null}
                <p className="obras-hito-confirm__hint">Queda pendiente de guardar junto al resto de cambios de la ficha.</p>

                <div className="obras-confirm__actions">
                    <button type="button" className="obras-confirm__cancel" onClick={onClose}>Cancelar</button>
                    <button type="submit" className="obras-confirm__confirm">Aplicar</button>
                </div>
            </form>
        </div>
    );
}
